// @ts-expect-error static asset
import templateMarketplaceImageUrl from 'bender-url!../../img/asset-marketplace-themes-1x.png';
// @ts-expect-error static asset
import templateMarketplaceImageUrl2x from 'bender-url!../../img/asset-marketplace-themes-2x.png';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import { getTemplateMarketplaceUrl } from '../utils/urls';
import MediaSection from './MediaSection';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AssetMarketplaceSection({
  onTrackInteraction
}) {
  return /*#__PURE__*/_jsx(MediaSection, {
    button: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "asset-marketplace-button",
      href: getTemplateMarketplaceUrl(),
      onClick: () => onTrackInteraction('click asset marketplace section button'),
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceUnified.sections.templateMarketplace.buttonText"
      })
    }),
    color: "fill-surface-default",
    "data-test-id": "asset-marketplace-section",
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.templateMarketplace.description"
    }),
    media: /*#__PURE__*/_jsx(Image, {
      src: templateMarketplaceImageUrl,
      srcSet: `${templateMarketplaceImageUrl2x} 2x`,
      inlineSize: "100%",
      maxInlineSize: "500px"
    }),
    orientation: "media-left",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.templateMarketplace.title"
    })
  });
}